const Wrapper = (props) => props.children;

export default Wrapper;


// WEBPACK FOOTER //
// ./src/hoc/Wrapper.js